// extracted by mini-css-extract-plugin
export default {"subtotalPriceContainer":"UFIvCBY3lXij_cLeKb6A","subtotalRow":"XjbkeR1wgxqpL_L0uuax","dimmed":"WKCOhH08hV7XtmUBZM3q"};